<template>
    <div class="content-layout padded">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="page-heading album-page-heading">
                        <div class="d-md-inline-block float-md-left">
                            <h1 class="album-name">{{ album.name }}. <span v-if="totalImages" class="light"><nobr>{{ totalImages }} files.</nobr></span></h1>
                        </div>
                        <nuxt-link :to="{ name: 'contributor-profile', params: {slug: contributor.slug} }" style="color:inherit">
                            <div class="d-md-inline-block float-md-right contributor-region-block">
                                <span class="name">By {{ contributor.name }}</span>
                                <span class="region">{{ contributor.location }}</span>
                            </div>
                        </nuxt-link>
                        <div class="clearfix"></div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div id="search-results-container" class="pb-0" :class="{'pb-0':done}">
                        <loading :loading="imagesLoading" :full-page="false"/>
                        <div class="similar-images-wrap">
                            <stock-image-thumbnail v-for="image in albumImages" :key="image.id" :image="image" :show-in-album-link="false"/>
                            <infinite-loading :identifier="infiniteId" @infinite="getImages">
                                <div slot="spinner"/>
                                <div slot="no-results"/>
                            </infinite-loading>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="padded-block">
                        <h2>Tags from this album</h2>
                        <div class="image-tags">
                            <loading :loading="tagsLoading" :full-page="false"/>
                            <nuxt-link v-for="tag in tags" :key="tag.id" class="tag" :to="`/search?term=${ tag.name}`">{{ tag.name }}</nuxt-link>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="locale === 'nz'" class="row tailored-ad-row">
                <div class="col-lg-4 col-md-12">
                    <h2 class="mb-sm-4 mb-lg-0">Need custom content with exclusive rights?</h2>
                </div>
                <div class="col-lg-7 offset-lg-1 col-md-12">
                    <p>With <strong>Tailored Content</strong> we offer simple packages that include talent, location and photographer fees to create <strong>custom content</strong> exclusively for your organisation or client.</p>
                    <nuxt-link :to="{ name: 'tailored' }">Read More</nuxt-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import StockImageThumbnail from '~/components/StockImageThumbnail'
import Loading from '~/components/global/Loading'

export default {
    components: {
        Loading,
        StockImageThumbnail
    },
    async asyncData ({
        error,
        params,
        redirect
    }) {
        try {
            const response = await axios.get(`/contributor/${params.slug}/albums/${params.album_id}`).then(rsp => rsp.data)

            if (response.album) {
                if (!params.album_slug || params.album_slug !== response.album.slug) {
                    redirect(302, response.album.link)
                }

                return {
                    album: response.album,
                    contributor: response.contributor
                }
            } else {
                redirect(`/contributor/${params.image_id}`)
            }
        } catch (err) {
            error({
                statusCode: 404,
                message: 'Page not found'
            })
        }
    },
    data () {
        return {
            album: null,
            contributor: null,
            albumImages: [],
            page: 1,
            infiniteId: +new Date(),
            randomSeed: Math.floor(Math.random() * 1000),
            imagesPerPage: 40,
            done: false,
            totalImages: null,
            tags: null,
            tagsLoading: true,
            imagesLoading: true
        }
    },
    head () {
        const title = `${this.album.name} by ${this.contributor.name} on Truestock`
        const description = this.contributor.description

        return {
            title,
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: description
                },
                {
                    hid: 'og:description',
                    property: 'og:description',
                    content: description
                },
                {
                    hid: 'twitter:description',
                    name: 'twitter:description',
                    content: description
                },
                {
                    hid: 'og:title',
                    property: 'og:title',
                    content: title
                },
                {
                    hid: 'twitter:title',
                    name: 'twitter:title',
                    content: title
                },
                {
                    hid: 'og:image',
                    property: 'og:image',
                    content: this.contributor.profile_image_url
                },
                {
                    hid: 'twitter:image',
                    name: 'twitter:image',
                    content: this.contributor.profile_image_url
                }
            ]
        }
    },
    mounted () {
        this.getTotalImages()
        this.getAlbumTags()
    },
    methods: {
        getTotalImages () {
            axios({
                method: 'get',
                url: `/contributor/${this.contributor.slug}/albums/${this.album.id}/total-images`
            }).then(rsp => rsp.data)
                .then((rsp) => {
                    this.totalImages = rsp.total
                })
        },
        getAlbumTags () {
            axios({
                method: 'get',
                url: `/contributor/${this.contributor.slug}/albums/${this.album.id}/tags`
            }).then(rsp => rsp.data)
                .then((rsp) => {
                    this.tags = rsp.tags
                })
                .finally(() => {
                    this.tagsLoading = false
                })
        },
        getImages ($state) {
            axios({
                method: 'get',
                url: `/contributor/${this.contributor.slug}/albums/${this.album.id}/images`,
                params: {
                    page: this.page,
                    randomSeed: this.randomSeed,
                    perPage: this.imagesPerPage
                }
            }).then(rsp => rsp.data)
                .then((rsp) => {
                    if (rsp.data.length) {
                        this.page += 1
                        this.albumImages.push(...rsp.data)
                        $state.loaded()
                    } else {
                        this.done = true
                        $state.complete()
                    }
                })
                .finally(() => {
                    this.imagesLoading = false
                })
        }
    }
}
</script>

<style scoped>

</style>
